import { BusinessIndicator, UpdateBusinessIndicator } from '@/entities/businessIndicator';
import { Api } from './api/axios-config';

export class BusinessIndicatorService{
  private static api = Api();

  public static async getBusinessIndicator(){
    const response = await this.api.get<any>('/business-indicator');
    if(response.status === 200){
      const businessIndicator = response.data.map((data:any)=>({
        id:data.id,
        commission: data.commission,
        indicatorId: data.indicatorId,
        businessId: data.businessId,
      }));
      return businessIndicator;
    }
    return null;
  }

  public static async createBusinessIndicator(businessIndicator:BusinessIndicator){
    const response = await this.api.post<any>('/business-indicator/create', {
      commission: businessIndicator.commission,
      indicatorId: businessIndicator.indicatorId,
      businessId: businessIndicator.businessId,
    });
    if(response.status === 201){
      const newBusinessIndicator ={
        id: response.data.id,
        commission: response.data.commission,
        indicatorId: response.data.indicatorId,
        businessId: response.data.businessId,
      };
      return newBusinessIndicator;
    }
  }

  public static async updateBusinessIndicator(id:number, updateBusinessIndicator:BusinessIndicator){
    const response = await this.api.post<any>(`/business-indicator/update/${id}`,{commission:updateBusinessIndicator.commission});
    if(response.status === 201){
      return response.data;
    }
    return null;   
  }

  public static async updateBusinessIndicatorId(businessId:number, indicatorId:number ){
    const response = await this.api.patch<any>(`/business-indicator/${businessId}/${indicatorId}`);
    if(response.status === 201){
      return response.data;
    }
    return null;   
  }

  public static async deleteBusinessIndicator(id:number, businessId:number){
    await this.api.delete<any>(`/business-indicator/delete/${id}/${businessId}`);
  }
}
